

export function formatDateToDisplay(dateString?: string): string {
    if (!dateString) return ''
    return new Date(dateString).toString()
}